import type { ReactElement } from 'react'
import styled from 'styled-components'

import { Accordion } from '@/components/elements/Accordion'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { Paragraph } from '@/components/enlayouts/Ir/Paragraph'
import { PDFList } from '@/components/enlayouts/Ir/PDFList'

const midTermPlanDocument = {
  id: '20260212-92a4d559',
  fileName:
    'Medium-Term Management Plan (FY6/2027 - FY6/2029) February 12, 2026',
  filePath: 'https://pdf.irpocket.com/C141A/xoA3/IjHJ/JWlA/l2Y5.pdf',
}

const midTermPlanPdfGroups = [
  {
    accordionTitle: 'FY6/2027 - FY6/2029',
    accordionItems: [midTermPlanDocument],
    isDefaultOpen: true,
  },
]

const midTermPlanDescription =
  'TRIAL Holdings, Inc. has formulated a three-year Mid-Term Management Plan covering the period from FY6/2027 through FY6/2029.\n\n' +
  'Under the Plan, we will steadily advance the PMI of SEIYU and strengthen its financial position by enhancing cash generation through the realization of integration synergies. At the same time, the Company will establish a solid business foundation for further growth beyond FY6/2030, including by developing a successful next-generation store format.'

export const MidTermPlan = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Medium-Term Management Plan"
        subTitleText=""
      />
      <PlanImage
        src="/images/ir-library-medium-term-plan.jpg"
        alt=""
        width="2020"
        height="1120"
      />
      <PlanDescription>{midTermPlanDescription}</PlanDescription>
      <Spacer h={{ sp: 70, pc: 120 }} />
      <AccordionArea>
        {midTermPlanPdfGroups.map((value, index) => (
          <div key={`${index}${value.accordionTitle}`}>
            <Accordion
              accordionTitle={value.accordionTitle}
              contentsLength={value.accordionItems.length}
              isDefaultOpen={value.isDefaultOpen}
            >
              <PDFList pdfList={value.accordionItems} />
            </Accordion>
          </div>
        ))}
      </AccordionArea>
    </Layout>
  )
}

MidTermPlan.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Management Policy', path: '/en/ir/library/' },
    { name: 'Medium-Term Management Plan', path: '' },
  ]

  return (
    <>
      <Head
        title="Medium-Term Management Plan"
        description="Our group's Medium-Term Management Plan (FY6/2027 - FY6/2029)."
        ogp={{ url: 'en/ir/library/midtermplan/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const AccordionArea = styled(Paragraph).attrs({ as: 'section' })`
  display: flex;
  flex-direction: column;
  gap: 50px;
  width: 100%;
`

const PlanImage = styled.img`
  display: block;
  width: 100%;
  max-width: 682px;
  height: auto;
  margin: 30px auto 0;
`

const PlanDescription = styled(Paragraph)`
  width: 100%;
  margin: 24px 0 0;
  color: #333;
  letter-spacing: 0;
  white-space: pre-line;
`
